import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PasswordParams} from "../models/passwordParams.model";
import { TemporaryUserResetEmail } from '../models/temporaryuseresetemail.model';
import { environment } from '../environments/environment';
import { User } from '../models/user.model';
@Injectable({
  providedIn: 'root'
})
export class ResetUserEmailService {

  constructor(private http: HttpClient) { }

  resetEmailAdressSendLik(userResetEmail:TemporaryUserResetEmail){
    return this.http.post<any>(`${environment.url}/email-reset/send-reset-link/`,userResetEmail);
  }

  resetEmailAdress(userResetEmail:TemporaryUserResetEmail){
    return this.http.put<User>(`${environment.url}/email-reset/reset-email/`+userResetEmail.id, userResetEmail);
  }


  verifEmailExist(email: String){
    return this.http.get<any>(`${environment.url}/email-reset/verify/`+ email);
  }


}
